import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";

import { Dimmer } from "../../spinner";


import {
    validaSoloNumero,
    formatMoneda,
    validaMonto,
    formatoMonto,
} from "../../../util/varios";
import TablaDeudaComercio from "../actividadEconomica/tablaDeudaComercios";
import TablaPagosComercio from "../actividadEconomica/tablaPagosComercios";
import TablaFacturasContribuyente from "../actividadEconomica/tablaFacturasContribuyentes";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import TablaDeudasEjidos from "./tablaDeudaEjidos";
import TablaHistoricosEjidos from "./tabaHistoricoEjidos";
import { CatalagoInmo2 } from "../../../catalogos/catalogoRentasInm";
import axios from "axios";
import TabPrueba from "../../../util/tabsPrueba";

export const RegistroResiduosSolidos = (props) => {
    /*  variables de estados */

    let op = require("../../../../src/modulos/datos");
    let token = localStorage.getItem("jwtToken");
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    const factorCambio = JSON.parse(localStorage.getItem('factorCambio'));
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrar5, setMostrar5] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [contar1, setContar1] = useState(0);
    const [activate, setActivate] = useState(false);
    const [mostrar, setMostrar] = useState(false);
    const [, setDeshabilitado] = useState(true);
    const [operacion, setOperacion] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [visible, setVisible] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [declaWeb, setDeclaWeb] = useState();
    const [mPagar, setMPagar] = useState(0);
    const txtIdComercio = useRef();
    const txtRitm = useRef();
    const txtDirecI = useRef();
    const txtCodCats = useRef();
    const txtTipoRenta = useRef();
    const [inmueble, setInmueble] = useState();
    const [comercio, setComercio] = useState();
    const txtCheckInmueble = useRef();
    const txtTipoContri = useRef();
    const txtTipoActividad = useRef();

    const txtCheckComercio = useRef();
    const txtCodCon = useRef();
    const [cat, setCat] = useState(1);
    const txtCheckNatural = useRef();
    const txtCheckJuridico = useRef();
    const txtRazonS = useRef();
    const cmbCedRif = useRef();
    const txtCedRif = useRef();
    const txtTlf = useRef();
    const txtDirecI2 = useRef();
    const txtActivP = useRef();
    const txtClasificador = useRef();
    const [anio, setAnio] = useState([]);
    const txtid = useRef();
    const [tipopersona, setTipoPersona] = useState(4);
    const [status, setStatus] = useState(0);
    const [desabiltar, setDesabilitar] = useState();
    const txtActivo = useRef();
    const txtInactivo = useRef();
    const txtMontoPagar = useRef(null);
    const [fechaSistema, setFechaSistema] = useState(
        localStorage.getItem("fechasistema")
    );
    const [nanio, setNanio] = useState();
    const [desde, setDesde] = useState();
    const [hasta, setHasta] = useState();
    const txtHasta = useRef();
    const txtDesde = useRef();
    const [acp, setAcp] = useState(null);
    const [mostarActividad, setMostarActividad] = useState();
    const [tecla, setTecla] = useState();
    const txtAñoDeuda = useRef();
    const [tab1, setTab1] = useState("black");
    // const [factorCambio, setFactorCambio] = useState(0)
    const [deuda, setDeuda] = useState();
    const [desde1, setDesde1] = useState(0);
    const [desde2, setDesde2] = useState(0);

    const styleTabs = {
        borderTop: "1px solid",
        borderColor: "rgba(0, 88, 129, 1)",
        borderLeft: "none",
        borderTopRightRadius: "16px",
    };

    /*********************************************** FUNCINES DE VALIDACION***********************************************************/

    const handleInputMonto = (event) => {
        //setActiveIndex(1);
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof event.which === "undefined") {
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === "0" && char2 !== ",") {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.which === 13) {
                if (event.target.id === "montoPagar") {
                    txtMontoPagar.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false; //alert(e.which);
    };

    const validarCamposDeuda = (event) => {
        event.preventDefault();

        var sigue = true;

        if (operacion === 2) {
            if (txtAñoDeuda.current.value === "") {


                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar el Año para cargar la Deuda', icono: 'informacion' });


                txtAñoDeuda.current.focus();
                sigue = false;
            } else if (
                txtDesde.current.value === "" ||
                txtHasta.current.value === ""
            ) {


                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar el periodo de inicio y final', icono: 'informacion' });

                txtDesde.current.focus();
                sigue = false;
            } else if (parseInt(txtDesde.current.value) > parseInt(txtHasta.current.value)) {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha de inicio no puede ser mayor a la fecha final', icono: 'informacion' });


                txtDesde.current.value = "";
                txtHasta.current.value = "";
                txtDesde.current.focus();
                sigue = false;
            } else if (txtMontoPagar.current.value === "" || txtMontoPagar.current.value === "0,00") {


                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar un monto para la deuda', icono: 'informacion' });


                txtMontoPagar.current.focus();
                sigue = false;
            } else if (sigue) {
                actualizarDeuda();
            }
        }
    };

    const verificarTipoContri = () => {
        if (txtCheckComercio.current.checked || txtCheckInmueble.current.checked) {
            setMostrar5(true);
        } else if (
            !txtCheckComercio.current.checked ||
            !txtCheckInmueble.current.checked
        ) {

            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar un tipo de Contribuyente', icono: 'informacion' });


        }
    };

    const cerrarModalActualizar = () => {
        setMostrar5(false);
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });

        if (
            mensaje.texto == "registro creado correctamente." ||
            mensaje.texto == "registro modificado correctamente." ||
            mensaje.texto == "registro eliminado correctamente."
        ) {
            blanquear();
            props.onHideCancela();
        }

        if (mensaje.texto === "Deuda Cargada") {
            //props.onHideRenderizar2(props.inmobiliaria);
            props.onHideRenderizar();
            /*txtAñoDeuda.current.value = "";
             txtDesde.current.value = "";
             txtHasta.current.value = "";
             txtMontoPagar.current.value = "";*/
        }
    };

    const handleChangeTipoPersona = (event) => {
        if (event.target.value === "0") {
            setTipoPersona(0);
            txtCheckNatural.current.checked = true;
            txtCheckJuridico.current.checked = false;
        } else {
            setTipoPersona(1);
            txtCheckNatural.current.checked = false;
            txtCheckJuridico.current.checked = true;
        }

    };

    const salir = () => {
        props.onHideCancela();
        blanquear();
    };

    const verifcarTipoCatalogo = () => {
        if (txtCheckInmueble.current.checked) {
            blanquear();
            setCat(1);
            setMostarActividad(false);
        } else if (txtCheckComercio.current.checked) {
            blanquear();
            setCat(0);
            setMostarActividad(true);
        }
    };

    const blanquear = () => {
        setMostrar(false);
        setTitulo("");
        setMsg("");
        setActivate(false);
        setDeuda();
        setDesde1(0);
        setDesde2(0);
        setTipoPersona(4);
        setMPagar(0);
        txtCodCats.current.value = " ";
        txtDirecI.current.value = " ";
        txtDirecI2.current.value = " ";
        txtRazonS.current.value = " ";
        txtCedRif.current.value = " ";
        txtTlf.current.value = " ";
        txtTipoRenta.current.value = "";
        txtClasificador.current.value = "";
        setDesde();
        setHasta();
        setNanio();
        setTabIndex(0);
    };

    const onChange = (event) => {

        if (event.target.name === 'clasificador' && operacion === 2) {
            const selectedIndex = txtClasificador.current.selectedIndex;
            let monto = "0,00";
            if (selectedIndex > 0){
                monto = JSON.stringify(props.clasificador[selectedIndex - 1].monto.toString().replace('"', ''))
            }
            



            ///let tot = parseFloat(monto.toString().replace(/"/g, '')) * parseFloat(props.factorCambio);
            let tot = parseFloat(monto.toString().replace(/"/g, ''));


            setMPagar(tot);
            txtMontoPagar.current.value = formatMoneda(tot.toString().replace(',', '').replace('.', ','), ',', '.', 2)
        }
        if (
            event.target.name === "razonS" ||
            event.target.name === "directInm" ||
            event.target.name === "actP" ||
            event.target.name === "ritm" ||
            event.target.name === "codCon" ||
            event.target.name === "codCats" ||
            event.target.name === "directInm" ||
            event.target.name === "directInm2" ||
            event.target.name === "actividadP"
        ) {
            event.target.value = event.target.value.toUpperCase();
        }

        if (event.target.name === "anioDeuda") {
            let nan = event.target.value;
            setNanio(parseFloat(nan));
        }

        if (event.target.name === "selectDesde") {
            let nan = event.target.value;
            setDesde(parseFloat(nan));
        }

        if (event.target.name === "selectHasta") {
            let nan = event.target.value;
            setHasta(parseFloat(nan));
        }

        if (event.target.name === "clasificador") {
            txtClasificador.current.value = event.target.value;
        }

        if (event.target.value === "tab2") {
            setTab1("blue");
        }
    };

    const validarContribuyente = (event) => {
        validaSoloNumero(event);

        if (event.which === 13 || typeof event.which === "undefined") {
            if (event.target.value !== "") {
                setTecla(event.which);
                if (cat === 0) {
                    onKeyUpInm(event.target.value);

                } else {
                    onKeyUpComr(event.target.value);
                }
            }
        } else {
            txtCodCats.current.value = "";
            txtDirecI.current.value = "";
            txtDirecI2.current.value = "";
            txtRazonS.current.value = "";
            if (tipopersona === 0) {
                cmbCedRif.current.value = "V";
            } else {
                cmbCedRif.current.value = "J";
            }
            txtCedRif.current.value = "";
            txtRitm.current.value = "";
            //txtDesde.current.value = "";
            //txtHasta.current.value = "";
            txtTlf.current.value = "";
            txtTipoActividad.current.value = "";
        }
    };

    const handlerClickTab = (index, lastIndex, event) => {
        //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
        if (props.operacion === 1 && (index === 1 || index === 2)) {
            setTabIndex(0);
        } else {
            setTabIndex(index);
        }
    };

    /*********************************************** FUNCINES DE CONSULTAS ***********************************************************/



    const handleAceptaInmueble = (
        id,
        ritm,
        nombR,
        cedrif,
        areaC,
        areaT,
        usoInm,
        fechAvalu,
        codicatas,
        direct,
        direct2,
        valor,
        usoI,
        tlf
    ) => {
        setMostrar5(false);

        if (parseInt(cat) === 0) {
            txtCodCon.current.value = id;
            if (codicatas !== null) {
                txtCodCats.current.value =
                    codicatas.substring(0, 2) +
                    "-" +
                    codicatas.substring(2, 4) +
                    "-" +
                    codicatas.substring(4, 6) +
                    "-" +
                    codicatas.substring(6, 7) +
                    "-" +
                    codicatas.substring(7, 9) +
                    "-" +
                    codicatas.substring(9, 12) +
                    "-" +
                    codicatas.substring(12, 15) +
                    "-" +
                    codicatas.substring(15, 18) +
                    "-" +
                    codicatas.substring(18, 21) +
                    "-" +
                    codicatas.substring(21, 24) +
                    "-" +
                    codicatas.substring(24, 27);
            } else {
                txtCodCats.current.value = "";
            }

            txtDirecI.current.value = direct;
            // txtDirecI2.current.value = direct2;
            //txtRazonS.current.value = nombR;
            //txtCedRif.current.value = cedrif;

        } else {
            txtCodCon.current.value = id;
            if (codicatas !== null) {
                txtCodCats.current.value =
                    codicatas.substring(0, 2) +
                    "-" +
                    codicatas.substring(2, 4) +
                    "-" +
                    codicatas.substring(4, 6) +
                    "-" +
                    codicatas.substring(6, 7) +
                    "-" +
                    codicatas.substring(7, 9) +
                    "-" +
                    codicatas.substring(9, 12) +
                    "-" +
                    codicatas.substring(12, 15) +
                    "-" +
                    codicatas.substring(15, 18) +
                    "-" +
                    codicatas.substring(18, 21) +
                    "-" +
                    codicatas.substring(21, 24) +
                    "-" +
                    codicatas.substring(24, 27);
            } else {
                txtCodCats.current.value = "";
            }
            txtDirecI.current.value = direct;
            txtDirecI2.current.value = direct;
            txtRazonS.current.value = nombR;
            let letra = "";
            let pos = 0;
            let tipo = 0;
            if (cedrif.toUpperCase().charCodeAt(0) > 64 && cedrif.toUpperCase().charCodeAt(0) < 91) {
                letra = cedrif.substring(0, 1);
                pos = 1;
                if (letra === "V" || letra === "E") {
                    tipo = 0;
                } else {
                    tipo = 1;
                }
            } else {
                tipo = 1;
                letra = "J";
                pos = 0;
            }
            setTipoPersona(tipo);
            if (tipo === 0) {
                txtCheckNatural.current.checked = true;
                txtCheckJuridico.current.checked = false;
            } else {
                txtCheckNatural.current.checked = false;
                txtCheckJuridico.current.checked = true;
            }

            cmbCedRif.current.value = letra;
            txtCedRif.current.value = cedrif.substring(pos, cedrif.trim().length);
            txtTlf.current.value = tlf;
        }


    };

    const handleAceptaComercio = (
        id,
        direct,
        nombR,
        cedrif,
        tlf,
        direct2,
        actP
    ) => {
        setMostrar5(false);

        txtCodCon.current.value = id;
        txtDirecI.current.value = direct;
        txtRazonS.current.value = nombR;
        txtCedRif.current.value = cedrif;
        txtTlf.current.value = tlf;
        txtDirecI2.current.value = direct2;
        txtActivP.current.value = actP;
    };

    const onKeyUpInm = (idinmueble) => {
        let campos = "*";
        let nomtab = "inmueble";
        let nomid = "idinmueble";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    if (response.data !== "") {
                        txtCodCats.current.value =
                            response.data.codigocatastral.substring(0, 2) +
                            "-" +
                            response.data.codigocatastral.substring(2, 4) +
                            "-" +
                            response.data.codigocatastral.substring(4, 6) +
                            "-" +
                            response.data.codigocatastral.substring(6, 7) +
                            "-" +
                            response.data.codigocatastral.substring(7, 9) +
                            "-" +
                            response.data.codigocatastral.substring(9, 12) +
                            "-" +
                            response.data.codigocatastral.substring(12, 15) +
                            "-" +
                            response.data.codigocatastral.substring(15, 18) +
                            "-" +
                            response.data.codigocatastral.substring(18, 21) +
                            "-" +
                            response.data.codigocatastral.substring(21, 24) +
                            "-" +
                            response.data.codigocatastral.substring(24, 27);


                        txtDirecI.current.value =
                            response.data.dirinmue1 !== null
                                ? response.data.dirinmue1.trim() + ": "
                                : "" + response.data.descridirinmue1 !== null
                                    ? response.data.descridirinmue1.trim() + ", "
                                    : "" + response.data.dirinmue5 !== null
                                        ? response.data.dirinmue5.trim() + ": "
                                        : "" + response.data.descridirinmue2 !== null
                                            ? response.data.descridirinmue2.trim() + ", "
                                            : "" + response.data.ciudadocupante !== null
                                                ? response.data.ciudadocupante.trim()
                                                : "";
                        setActivate(false)

                    } else {
                        txtCodCon.current.value = "";
                        if (tecla === 13) {

                            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Inmueble no existe.', icono: 'error' });


                        }
                    }
                }

                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

                setActivate(false);
            });
    };

    const onKeyUpComr = (idcomercio) => {
        let campos = "*";
        let nomtab = "comercio";
        let nomid = "idcomercio";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcomercio}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    if (response.data !== "") {
                        txtCodCats.current.value = "";
                        txtDirecI.current.value = response.data.direccion;
                        txtDirecI2.current.value = response.data.direccion;
                        txtRazonS.current.value = response.data.nombre;
                        let letra = "";
                        let pos = 0;
                        let tipo = 0;
                        if (response.data.rif.toUpperCase().charCodeAt(0) > 64 && response.data.rif.toUpperCase().charCodeAt(0) < 91) {
                            letra = response.data.rif.substring(0, 1);
                            pos = 1;
                            if (letra === "V" || letra === "E") {
                                tipo = 0;
                            } else {
                                tipo = 1;
                            }
                        } else {
                            tipo = 1;
                            letra = "J";
                            pos = 0;
                        }
                        setTipoPersona(tipo);
                        if (tipo === 0) {
                            txtCheckNatural.current.checked = true;
                            txtCheckJuridico.current.checked = false;
                        } else {
                            txtCheckNatural.current.checked = false;
                            txtCheckJuridico.current.checked = true;
                        }

                        cmbCedRif.current.value = letra;
                        txtCedRif.current.value = response.data.rif.substring(pos, response.data.rif.trim().length);

                        txtTlf.current.value = response.data.telefono;
                        //txtActivP.current.value = response.data.tipoactividad;
                        setActivate(false)
                    } else {
                        txtCodCon.current.value = "";
                        if (tecla === 13) {

                            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Comercio no existe.', icono: 'error' });


                        }
                    }
                }

                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

                setActivate(false);
            });
    };

    const tipoContri = (e) => {
        setCat(parseInt(e.target.value))
        txtCodCon.current.value = ''
        txtCodCats.current.value = "";
        txtDirecI.current.value = "";
        txtDirecI2.current.value = "";
        txtRazonS.current.value = "";
        txtCedRif.current.value = "";

        txtRitm.current.value = "";
        /*txtDesde.current.value = "";
        txtHasta.current.value = "";*/
        txtTlf.current.value = "";

    }

    /*********************************************** FUNCINES DE ACTUALIZACON Y REGISTRO*************************************************/
    const actualizarDeuda = () => {
        let endpoint ='';
        let body;
        if (espiritu === 0){
            endpoint = `${op.conexion}/api/aseo/creardeudarenta`;
            body = {
                operacion: 1,
                id: parseInt(
                    props.inmobiliaria
                        ? props.inmobiliaria.idrentas !== null
                            ? props.inmobiliaria.idrentas.trim()
                            : ""
                        : ""
                ),
                nomtab: "deudarentas",
                nomid: "idrentas",
                peri: props.periodoPagoR,
                //monto: parseFloat(
                //txtMontoPagar.current.value.replace(/\./g, "").replace(",", ".") /
                //props.periodoR /
                //props.valorUT,
                //4
                //),
                monto: parseFloat(txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."), 4),
                nanio: parseInt(txtAñoDeuda.current.value),
                mesdesde: parseInt(txtDesde.current.value),
                meshasta: parseInt(txtHasta.current.value),
                nomiddeu: "iddeudarentas",
                tipo: 0,
            };
    
        } else {
            endpoint = `${op.conexion}/api/aseo/creardeudarenta1`;
            body = {
                operacion: 1,
                id: parseInt(
                  props.inmobiliaria
                    ? props.inmobiliaria.idrentas !== null
                      ? props.inmobiliaria.idrentas.trim()
                      : ""
                    : ""
                ),
                nomtab: "deudarentas",
                monto: parseFloat(txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."), 4),
                nanio: parseInt(txtAñoDeuda.current.value),
                mesdesde: parseInt(txtDesde.current.value),
                meshasta: parseInt(txtHasta.current.value),
                peri: props.periodoPagoR,
              };
        }
        //let endpoint = `${op.conexion}/api/aseo/creardeudarenta1`;


        setActivate(true);

        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then((response) => {
                if (response.status == 200) {
                    setActivate(false);

                    setDesde1(1);
                    SelectDeudaC(txtid.current.value);
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Deuda Cargada', icono: 'exito' });


                }
            })
            .catch((error) => {
                setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

                setActivate(false);
            });
    };

    const opcionesRegistro = (e) => {
        e.preventDefault();
        var sigue = true;
        if (operacion !== 4) {
            if (txtTipoRenta.current.value === "") {


                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar un tipo de Renta', icono: 'informacion' });


                txtTipoRenta.current.focus();

                sigue = false;
            } else if (txtCodCon.current.value === "") {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar un contribuyente con el Boton "BUSCAR"', icono: 'informacion' });


                txtCodCon.current.focus();

                sigue = false;
            } else if (
                !txtCheckJuridico.current.checked &&
                !txtCheckNatural.current.checked
            ) {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar si es Prs.Natural o Prs.Juridica', icono: 'informacion' });


                txtCheckJuridico.current.focus();

                sigue = false;
            } else if (cmbCedRif.current.value === "") {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar la Letra de la Cedula o Rif', icono: 'informacion' });

                cmbCedRif.current.focus();
                sigue = false;
            } else if (txtCedRif.current.value === "") {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar el Número de Cedula o Rif', icono: 'informacion' });

                txtCedRif.current.focus();
                sigue = false;
            } else if (txtTlf.current.value === "") {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar un Número de Telefono Valido', icono: 'informacion' });

                txtTlf.current.value = "";
                txtTlf.current.focus();
                sigue = false;
            } else if (txtRazonS.current.value === "") {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar el Nombre o Razon Social', icono: 'informacion' });

                txtRazonS.current.focus();
                sigue = false;
            } else if (txtDirecI2.current.value === "") {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar la Dirección', icono: 'informacion' });

                txtDirecI2.current.focus();
                sigue = false;
            } else if (txtTipoActividad.current.value === "") {

                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar la Actividad Principal', icono: 'informacion' });

                txtTipoActividad.current.focus();
                sigue = false;
            } else if (txtClasificador.current.value === "") {


                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar una Clasificacion', icono: 'informacion' });


                sigue = false;
            } else if (sigue === true) {
                actualizarRenta(props.operacion);
            }


        }
    };

    const actualizarRenta = (operacion) => {
        let endpoint = `${op.conexion}/api/aseo/createaseo/${operacion}`;
        let body;
        setActivate(true);

        body = {
            nid: parseInt(txtid.current.value),
            idinmue: parseInt(txtCodCon.current.value),
            numcontra: null,
            feccontra: null,
            idTipren: txtTipoRenta.current.value,
            tipper: txtCheckNatural.current.checked ? 0 : txtCheckJuridico.current.checked ? 1 : null,
            nomarren: txtRazonS.current.value,
            dire: txtDirecI2.current.value === "" ? null : txtDirecI2.current.value,
            ced: txtCedRif.current.value === "" ? null : cmbCedRif.current.value + txtCedRif.current.value,
            tlf: txtTlf.current.value,
            fecini: null,
            fecfin: null,
            monarren: props.operacion === 1 ? mPagar : txtMontoPagar.current.value === "" ? 0 : txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."),
            tiparren: null,
            pericance: null,
            duracont: null,
            tiploc: null,
            numloc: null,
            tipacti:
                txtTipoActividad.current.value == ""
                    ? null
                    : txtTipoActividad.current.value,
            codimpu: parseInt(JSON.stringify(props.rentas[txtTipoRenta.current.selectedIndex].codigoimpuesto)),
            nritm: txtRitm.current.value,
            tiptab: cat,
            clasif: txtClasificador.current.value,
            sta: status,
            moti: null,
        };

        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    props.onHideRenderizar();

                    if (props.operacion === 1) {


                        setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente.', icono: 'exito' });


                    } else if (props.operacion === 2) {


                        setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente.', icono: 'exito' });


                    } else if (props.operacion === 3) {


                        setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente.', icono: 'exito' });


                    }
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

                setActivate(false);
            });
    };

    useEffect(() => {
        let anioact = JSON.parse(localStorage.getItem("efiscalanio"));
        var nanio = [];
        var aini = parseInt(anioact) - 7;
        var afin = parseInt(anioact);

        for (let i = 0; i + aini <= afin; i++) {
            nanio.push({ anio: afin - i });
        }
        setAnio(nanio);

        setDesabilitar(false);
    }, []);

    useEffect(() => {
        if (props.operacion !== 1 && props.inmobiliaria && props.inmobiliaria.tipopersona <= 1) {
            let letra = "";
            let pos = 0;
            let tipo = 4;
            if (desde2 === 0) {
                tipo = props.inmobiliaria.tipopersona;
                if (props.inmobiliaria.cedrif.toUpperCase().charCodeAt(0) > 64 && props.inmobiliaria.cedrif.toUpperCase().charCodeAt(0) < 91) {
                    letra = props.inmobiliaria.cedrif.substring(0, 1);
                    pos = 1;
                } else {
                    if (tipo === 0) {
                        letra = "V";
                    } else {
                        letra = "J";
                    }
                    pos = 0;
                }

                cmbCedRif.current.value = letra;
                txtCedRif.current.value = props.inmobiliaria.cedrif.substring(pos, props.inmobiliaria.cedrif.trim().length);
            } else {
                tipo = tipopersona;
                cmbCedRif.current.value = "";
            }
            setDesde2(1);
        }


    }, [tipopersona]);

    const verificar = () => {
        txtCodCon.current.value = " ";
        txtRitm.current.value = "";
        txtCodCats.current.value = " ";
        txtDirecI.current.value = " ";
        txtDirecI2.current.value = " ";
        txtRazonS.current.value = " ";
        txtCedRif.current.value = " ";
        txtTlf.current.value = " ";
        //txtTipoRenta.current.value = "";
        txtCheckNatural.current.checked = false;
        txtCheckJuridico.current.checked = false;


        setDesabilitar(false);
        setMostrar5(true);
    };

    const handleInputNumChange = (event) => {
        //setActiveIndex(1);
        validaSoloNumero(event);
        if (event.which === 13 || typeof event.which === "undefined") {
            if (event.target.id === "inputTlf") {
                txtTlf.current.value.toString().trim().padStart(2, 0);

                if (event.which === 13) {
                    txtTlf.current.focus();
                }
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false; //alert(e.which);
    };


    const SelectDeudaC = (idrentas) => {
        let tabla = "residuossolidos";
        let endpoint ='';
        if (espiritu === 0){
            endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
        } else {
            endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
        }
        //let endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
        //let endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {

                    var deu = [];
                    var his = [];
                    var anioactu = new Date(fechasistema).getFullYear();
                    var mesactu = (new Date(fechasistema).getMonth() + 1).toString().padStart(2, 0);
                    for (let i = 0; i < response.data.length; i++) {
                        if (response.data[i].fechapago === null) {
                            if (parseFloat(response.data[i].anio) < parseFloat(anioactu)) {
                                deu.push({
                                    anio: response.data[i].anio,
                                    mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                    monto: response.data[i].mondeu * factorCambio,
                                    intereses: response.data[i].intmoradeu * factorCambio,
                                    multa: response.data[i].multa * factorCambio,
                                    recargo: response.data[i].recargodeu * factorCambio,
                                });
                            } else if (parseFloat(response.data[i].nmes) <= parseFloat(mesactu)) {
                                deu.push({
                                    anio: response.data[i].anio,
                                    mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                    monto: response.data[i].mondeu * factorCambio,
                                    intereses: response.data[i].intmoradeu * factorCambio,
                                    multa: response.data[i].multa * factorCambio,
                                    recargo: response.data[i].recargodeu * factorCambio,

                                });
                            }
                        } else {
                            his.push({
                                anio: response.data[i].anio,
                                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                monto: response.data[i].mondeu,
                                intereses: response.data[i].intmoradeu,
                                recargo: response.data[i].recargodeu,
                                multa: response.data[i].multa,
                                descuento: response.data[i].mondescue,
                                recibo: response.data[i].numreci,
                                fechapago: response.data[i].fechapago,
                            });
                        }
                    }

                    setDeuda(deu);
                    //setHistorico(his);
                    setActivate(false);

                }

                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

                setActivate(false);
            }); /* .finally(function () {
            setValido({ ...valido, sigue1: 1 });
        }) */
    };
    const imprimirRelacionPago = () /*  => (event) */ => {
    /* event.preventDefault(); */
    var idcomercio = props.inmobiliaria.idrentas;
    window.open(
      op.reportes +
        "/rentasinmobiliarias?" +
        "reporte=PagosWebRentas" +
        "&ID=" +
        idcomercio +
        "&TIPO=(2,34,69)",
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };
    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                console.log(props.tipoContribuyente)

                setDesde1(0);
                setOperacion(props.operacion);
                setDesabilitar(false);
                setDeclaWeb(props.declaweb);
                setMostarActividad(false);

                /* setVisible(false);
                        setIdUsuario(props.idusuario);
                         */
                setTabIndex(0);
                if (props.operacion === 1) {
                    txtCheckNatural.current.checked = true;
                    txtCheckJuridico.current.checked = false;
                } else {
                    setDesde2(0);
                    setTipoPersona(props.inmobiliaria.tipopersona);
                    /*let letra = "";
                    let pos = 0;
                    let tipo = props.inmobiliaria.tipopersona;
                    setTipoPersona(tipo);
                    if (tipo === 0) {
                      txtCheckNatural.current.checked = true;
                      txtCheckJuridico.current.checked = false;
                    } else {
                      txtCheckNatural.current.checked = false;
                      txtCheckJuridico.current.checked = true;
                    }
                    if (props.inmobiliaria.cedrif.toUpperCase().charCodeAt(0) > 64 && props.inmobiliaria.cedrif.toUpperCase().charCodeAt(0) < 91) {
                      letra = props.inmobiliaria.cedrif.substring(0, 1);
                      pos = 1;
                    } else {
                      if (tipo === 0) {
                        letra = "V";
                      } else {
                        letra = "J";
                      }
                      pos = 0;
                    }
          
                    cmbCedRif.current.value = letra;
                    txtCedRif.current.value = props.inmobiliaria.cedrif.substring(pos, props.inmobiliaria.cedrif.trim().length);*/
                }
            }}
        >
            <Modal.Header className="azulGradiant">
                <Modal.Title style={{ color: "#fff" }}>
                    {operacion === 1
                        ? "Registrar Contribuyente Disposición de Residuos Sólidos."
                        : operacion === 2
                            ? "Editar Contribuyente Disposición de Residuos Sólidos."
                            : operacion === 3
                                ? "Eliminar Contribuyente Disposición de Residuos Sólidos."
                                : "Consultar Contribuyente Disposición de Residuos Sólidos"}
                </Modal.Title>
                <button
                    ref={btnCancela}
                    className="btn"
                    style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
                    onClick={salir}
                >
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ color: "rgb(106, 115, 123)" }}>
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <Dimmer active={activate} >
                </Dimmer>
                <div >
                    <CatalagoInmo2
                        show={mostrar5}
                        onHideCancela={cerrarModalActualizar}
                        cat={cat}
                        onHideAceptaCatInm={handleAceptaInmueble}

                    //    onHIdeAceptaCaCom={handleAceptaComercio}
                    />

                    <ul className="nav " id="ex-with-icons" role="tablist">
                        <li className="nav-item" role="presentation">
                            <a
                                className="rounded nav-link active bg-blue-100 text-light"
                                id="datosTributarios"
                                data-bs-toggle="tab"
                                data-bs-target="#tributarios"
                                type="button"
                                role="tab"
                                aria-controls="tributarios"
                                aria-selected="true"

                            >
                                Datos Generales
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="rounded nav-link bg-blue-200 text-light"
                                disabled={operacion === 1 || operacion === 3 ? true : false}
                                id="deuda-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#deuda"
                                type="button"
                                role="tab"
                                aria-controls="deuda"
                                aria-selected="false"

                            >
                                Deudas del Contribuyente
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="rounded nav-link bg-blue-300 text-light"
                                disabled={operacion === 1 || operacion === 3 ? true : false}
                                id="hist-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#historico"
                                type="button"
                                role="tab"
                                aria-controls="historico"
                                aria-selected="false"

                            >
                                Historicos de Pagos
                            </a>
                        </li>
                        <div className="input-group mr-0 input-group-sm mb-1 col-md-2">
                            <span className="input-group-text bg-transparent fw-bold border-0">Valor Euro €:</span>
                            <span className="input-group-text bg-transparent fw-bold border-0">{formatMoneda((factorCambio.valor || 0).toString().replace(',', '').replace('.', ','), ',', '.', 2)}</span>

                        </div>

                    </ul>

                    <div className="tab-content" id="myTabContent">
                        <div
                            className="tab-pane fade show active"
                            id="tributarios"
                            role="tabpanel"
                            aria-labelledby="datosTributarios"
                        >
                            <div
                                className="row col-md-12 rounded border-azul py-2  mx-auto"

                            >
                                <div className="input-group input-group-sm col-md-2 mb-1"

                                >

                                    <span className="input-group-text">Código: </span>

                                    <input
                                        type="text"
                                        ref={txtid}
                                        disabled
                                        className="form-control text-uppercase"
                                        defaultValue={
                                            props.inmobiliaria
                                                ? props.inmobiliaria.idrentas !== null
                                                    ? props.inmobiliaria.idrentas.trim()
                                                    : ""
                                                : ""
                                        }
                                        id="inputCodigo"
                                    />
                                </div>
                                <div className="input-group input-group-sm col-md-6 mb-1">
                                    <span className="input-group-text">
                                        Tipo de Renta:
                                    </span>

                                    <select
                                        name="idclasevehiculo"
                                        ref={txtTipoRenta}
                                        disabled={operacion === 1 ? false : true}
                                        value={
                                            props.inmobiliaria && props.inmobiliaria.idtiporenta
                                        }
                                        className="form-select col-md-7 top-0"
                                        id="inputTP"
                                    >
                                        {/*<option value={""}></option>*/}
                                        {props.rentas &&
                                            props.rentas.map((item, index) => (
                                                <option key={index} value={item.idtiporentas}>
                                                    {" "}
                                                    {item.descripcion}{" "}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col-md-4"></div>


                                <div className="input-group input-group-sm col-md-2 mb-1"

                                >

                                    <span className="input-group-text"> RITM: </span>

                                    <input
                                        type="text"
                                        ref={txtRitm}
                                        disabled
                                        className="form-control text-uppercase"
                                        defaultValue={
                                            props.inmobiliaria
                                                ? props.inmobiliaria.ritm !== null
                                                    ? props.inmobiliaria.ritm.trim()
                                                    : ""
                                                : ""
                                        }
                                        id="ritm"
                                        name="ritm"
                                        onChange={onChange}
                                    />
                                </div>


                                <div className="input-group input-group-sm col-md-3 mb-1"

                                >

                                    <span className="input-group-text">
                                        Cod. Comtrib:
                                    </span>

                                    <input
                                        type="text"
                                        ref={txtCodCon}
                                        className="form-control text-uppercase"
                                        disabled={operacion === 1 ? false : true}
                                        defaultValue={
                                            props.inmobiliaria
                                                ? props.inmobiliaria.idinmueble !== null
                                                    ? props.inmobiliaria.idinmueble.trim()
                                                    : ""
                                                : ""
                                        }
                                        id="codCon"
                                        name="codCon"
                                        onChange={onChange}
                                        onKeyUp={validarContribuyente}
                                        onBlur={validarContribuyente}
                                    />
                                    <button
                                        onClick={verificar}

                                        disabled={operacion === 1 ? false : true}
                                        className="btn btn-sm btn-info"
                                    >
                                        <i className="fas fa-search"> </i>{" "}
                                    </button>
                                </div>

                                <div className="col-md-3"></div>

                                <div className="input-group input-group-sm col-md-4 mb-1"  >
                                    <span className="input-group-text">
                                        Tipo de Contribuyente:
                                    </span>

                                    <select
                                        name="idclasevehiculo"
                                        ref={txtTipoContri}
                                        disabled={operacion === 1 ? false : true}
                                        defaultValue={
                                            1
                                        }

                                        onChange={tipoContri}
                                        className="form-select "
                                        id="inputTP"

                                    >
                                        <option value='1'>Comercio</option>
                                        <option value='0'>Inmueble</option>




                                    </select>
                                </div>

                                <div className="input-group input-group-sm col-md-5 mb-1"

                                >

                                    <span className="input-group-text">
                                        Código Catastral:{" "}
                                    </span>

                                    <input
                                        type="text"
                                        disabled
                                        ref={txtCodCats}
                                        className="form-control text-uppercase"
                                        defaultValue={
                                            props.inmueble
                                                ? props.inmueble.codigocatastral !== null
                                                    ? props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(0, 2) +
                                                    "-" +
                                                    props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(2, 4) +
                                                    "-" +
                                                    props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(4, 6) +
                                                    "-" +
                                                    props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(6, 7) +
                                                    "-" +
                                                    props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(7, 9) +
                                                    "-" +
                                                    props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(9, 12) +
                                                    "-" +
                                                    props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(12, 15) +
                                                    "-" +
                                                    props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(15, 18) +
                                                    "-" +
                                                    props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(18, 21) +
                                                    "-" +
                                                    props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(21, 24) +
                                                    "-" +
                                                    props.inmueble.codigocatastral
                                                        .trim()
                                                        .substring(24, 27)
                                                    : ""
                                                : ""
                                        }
                                        id="codCats"
                                        name="codCats"
                                        onChange={onChange}
                                    />
                                </div>



                                <div className="input-group input-group-sm col-md-7 mb-1"

                                >

                                    <span className="input-group-text">
                                        {" "}
                                        Dirección del Inmueble:{" "}
                                    </span>

                                    <input
                                        type="text"
                                        disabled
                                        ref={txtDirecI}
                                        className="form-control text-uppercase"
                                        defaultValue={
                                            props.inmobiliaria
                                                ? props.inmobiliaria.direccion !== null
                                                    ? props.inmobiliaria.direccion.trim()
                                                    : ""
                                                : ""
                                        }
                                        id="directInm"
                                        name="directInm"
                                        onChange={onChange}
                                    />
                                </div>


                                {operacion !== 1 ? (
                                    <div
                                        className="row col-md-12 mx-auto justify-content-start mt-2"

                                    >
                                        <div
                                            className="form-check form-check-inline col-md-2"

                                        >
                                            <label
                                                className="form-check-label"
                                                htmlFor="inlineRadio2"
                                            >
                                                Status
                                            </label>
                                        </div>

                                        <div
                                            className="form-check form-check-inline col-md-1"

                                        >
                                            <input
                                                className="form-check-input"
                                                ref={txtActivo}
                                                disabled={operacion === 2 ? false : true}
                                                type="radio"
                                                name="checkStatus"
                                                value={0}
                                                defaultChecked={
                                                    props.inmobiliaria && props.inmobiliaria.status === 0
                                                }
                                                id="checkStatus"
                                                onChange={(event) => setStatus(event.target.value)}
                                            />
                                            <label className="form-check-label">Activo</label>
                                        </div>

                                        <div
                                            className="form-check form-check-inline col-md-1"

                                        >
                                            <input
                                                className="form-check-input"
                                                ref={txtInactivo}
                                                disabled={operacion === 2 ? false : true}
                                                type="radio"
                                                name="checkStatus"
                                                value={1}
                                                defaultChecked={
                                                    props.inmobiliaria && props.inmobiliaria.status === 1
                                                }
                                                id="checkStatus"
                                                onChange={(event) => setStatus(event.target.value)}
                                            />
                                            <label className="form-check-label">Inactivo</label>
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}

                                <fieldset className=' row col-md-12 border-azul rounded mx-auto d-flex justify-content-between'>
                                    <legend className="float-none w-auto" >Datos del Arrendatario</legend>

                                    <div
                                        className="row col-md-6 mx-auto mb-1"
                                    >

                                        <label
                                            className="form-check-label col-md-6"

                                        >
                                            Tipos de Contribuyentes
                                        </label>
                                        <div className="form-check form-check-inline col">
                                            <input
                                                className="form-check-input"
                                                ref={txtCheckNatural}
                                                type="radio"
                                                disabled={operacion === 1 || operacion === 2
                                                    ? false
                                                    : true
                                                }
                                                name="radioPers"
                                                value={"0"}
                                                defaultChecked={
                                                    props.inmobiliaria &&
                                                    props.inmobiliaria.tipopersona === 0
                                                }
                                                id="radioPers"
                                                onChange={handleChangeTipoPersona}
                                            />
                                            <label className="form-check-label">Prs. Natural</label>
                                        </div>

                                        <div className="form-check form-check-inline col">
                                            <input
                                                className="form-check-input"
                                                ref={txtCheckJuridico}
                                                type="radio"
                                                disabled={operacion === 1 || operacion === 2
                                                    ? false
                                                    : true
                                                }
                                                name="radioPers"
                                                value={"1"}
                                                defaultChecked={
                                                    props.inmobiliaria &&
                                                    props.inmobiliaria.tipopersona === 1
                                                }
                                                id="radioPers"
                                                onChange={handleChangeTipoPersona}
                                            />
                                            <label className="form-check-label">
                                                Prs. Jurídica
                                            </label>
                                        </div>



                                    </div>

                                    <div className="input-group input-group-sm col-md-3 mb-1">

                                        <span className="input-group-text">
                                            {" "}
                                            Cedula/Rif:
                                        </span>

                                        {tipopersona === 0 ?
                                            <select ref={cmbCedRif} className="form-select col-3" id="inputCedRif"
                                                /*defaultValue={
                                                  props.inmobiliaria
                                                    ? props.inmobiliaria.cedrif !== null
                                                      ? props.inmobiliaria.cedrif.trim().toUpperCase().charCodeAt(0) > 64 && props.inmobiliaria.cedrif.trim().toUpperCase().charCodeAt(0) < 91
                                                        ? props.inmobiliaria.cedrif.trim().substring(0, 1)
                                                        : ""
                                                      : ""
                                                    : ""
                                                }*/
                                                disabled={operacion === 1 || operacion === 2 ? false : true}
                                            >
                                                <option value="V">V</option>
                                                <option value="E">E</option>
                                            </select>
                                            :
                                            <select ref={cmbCedRif} className="form-select col-3" id="inputCedRif"
                                                /*defaultValue={
                                                  props.inmobiliaria
                                                    ? props.inmobiliaria.cedrif !== null
                                                      ? props.inmobiliaria.cedrif.trim().toUpperCase().charCodeAt(0) > 64 && props.inmobiliaria.cedrif.trim().toUpperCase().charCodeAt(0) < 91
                                                        ? props.inmobiliaria.cedrif.trim().substring(0, 1)
                                                        : ""
                                                      : ""
                                                    : ""
                                                }*/
                                                disabled={operacion === 1 || operacion === 2 ? false : true}
                                            >
                                                <option value="J">J</option>
                                                <option value="V">V</option>
                                                <option value="G">G</option>
                                            </select>
                                        }

                                        <input
                                            type="text"
                                            ref={txtCedRif}
                                            disabled={operacion === 1 || operacion === 2
                                                ? false
                                                : true
                                            }
                                            className="form-control text-uppercase"
                                            defaultValue={
                                                props.inmobiliaria
                                                    ? props.inmobiliaria.cedrif !== null
                                                        ? props.inmobiliaria.cedrif.trim()
                                                        : ""
                                                    : ""
                                            }
                                            id="inputCodigo"
                                        />
                                    </div>

                                    <div className="input-group input-group-sm col-md-3 mb-1">

                                        <span className="input-group-text"> Telefono:</span>

                                        <input
                                            type="text"
                                            ref={txtTlf}
                                            minLength={11}
                                            maxLength={11}
                                            disabled={operacion === 1 || operacion === 2
                                                ? false
                                                : true
                                            }
                                            className="form-control text-uppercase"
                                            defaultValue={
                                                props.inmobiliaria
                                                    ? props.inmobiliaria.telefono !== null
                                                        ? props.inmobiliaria.telefono.trim()
                                                        : ""
                                                    : ""
                                            }
                                            id="inputTlf"
                                            name="inputTlf"
                                            onKeyUp={handleInputNumChange}
                                            onBlur={handleInputNumChange}
                                        />
                                    </div>

                                    <div className="input-group input-group-sm col-md-12 mb-1">

                                        <span className="input-group-text">
                                            Nombre o Razon Social:
                                        </span>

                                        <input
                                            type="text"
                                            ref={txtRazonS}
                                            disabled={operacion === 1 || operacion === 2
                                                ? false
                                                : true
                                            }
                                            className="form-control text-uppercase"
                                            defaultValue={
                                                props.inmobiliaria
                                                    ? props.inmobiliaria.nombrearrendatario !== null
                                                        ? props.inmobiliaria.nombrearrendatario.trim()
                                                        : ""
                                                    : ""
                                            }
                                            id="razonS"
                                            name="razonS"
                                            onChange={onChange}
                                        />
                                    </div>



                                    <div className="input-group input-group-sm col-md-12 mb-1">

                                        <span className="input-group-text">

                                            Dirección:
                                        </span>

                                        <textarea style={{ height: 70 }}
                                            type="textarea"
                                            ref={txtDirecI2}
                                            disabled={operacion === 1 || operacion === 2
                                                ? false
                                                : true
                                            }
                                            className="form-control text-uppercase"
                                            defaultValue={
                                                props.inmobiliaria
                                                    ? props.inmobiliaria.direccion !== null
                                                        ? props.inmobiliaria.direccion.trim()
                                                        : ""
                                                    : ""
                                            }
                                            id="directInm2"
                                            name="directInm2"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-group input-group-sm col-md-12 mb-1">

                                        <span className="input-group-text">

                                            Tipo de Actividad:
                                        </span>
                                        <textarea
                                            type="textarea"
                                            style={{ height: 70 }}
                                            ref={txtTipoActividad}
                                            disabled={operacion === 1 || operacion === 2
                                                ? false
                                                : true
                                            }
                                            className="form-control text-uppercase"
                                            defaultValue={
                                                props.inmobiliaria
                                                    ? props.inmobiliaria.tipoactividad !== null
                                                        ? props.inmobiliaria.tipoactividad.trim()
                                                        : ""
                                                    : ""
                                            }
                                            id="actividadP"
                                            name="actividadP"
                                            onChange={onChange}
                                        />
                                    </div>




                                </fieldset>


                                <fieldset className=' row col-md-12 border-azul rounded mx-auto d-flex justify-content-between'>

                                    <legend className="float-none w-auto" > <label
                                        className="form-check-label"
                                        disabled={
                                            operacion === 1
                                                ? desabiltar
                                                : operacion === 2
                                                    ? false
                                                    : true
                                        }
                                        htmlFor="inlineRadio2"
                                    >
                                        Información Inmueble
                                    </label></legend>


                                    <div className="row col-md-12 justify-content-start">
                                        <div className="input-group input-group-sm col-md-12 justify-content-start">
                                            <div
                                                className="input-group-prepend"
                                                style={{ height: 28 }}
                                            >
                                                <span className="input-group-text w-100">
                                                    Tipo Clasificacion:
                                                </span>
                                            </div>
                                            <select
                                                ref={txtClasificador}
                                                disabled={
                                                    operacion === 1
                                                        ? false
                                                        : operacion === 2
                                                            ? false
                                                            : true
                                                }
                                                defaultValue={
                                                    props.inmobiliaria &&
                                                    props.inmobiliaria.idclasificador
                                                }
                                                onChange={onChange}
                                                name="clasificador"
                                                className="form-select form-control form-control-sm col-md-6"
                                            >
                                                <option value="">Seleccionar</option>
                                                {props.clasificador &&
                                                    props.clasificador.map((item, index) => (
                                                        <option key={index} value={item.idclaseaseo}>
                                                            {" "}
                                                            {item.descripcion}{" "}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>

                                    {operacion !== 1 ? (
                                       <div className="col-md-12 d-flex align-items-center flex-nowrap" style={{ gap: '10px' }}>
  {/* Año */}
  <div className="d-flex align-items-center" style={{ gap: '5px' }}>
    <label htmlFor="inputDireccion4" className="mb-0">Año:</label>
    <select
      disabled={operacion === 1 || operacion === 2 ? false : true}
      ref={txtAñoDeuda}
      name="anioDeuda"
      onChange={onChange}
      className="form-control form-control-sm"
      style={{ width: '90px' }}
    >
      {anio && anio.map((a) => (
        <option key={a.anio} value={a.anio}>{a.anio}</option>
      ))}
    </select>
  </div>

  {/* Periodos */}
  <div className="d-flex align-items-center" style={{ gap: '5px' }}>
    <span className="mb-0">Periodos de Deuda:</span>
    <label className="mb-0">Desde</label>
    <select
      disabled={operacion === 1 || operacion === 2 ? false : true}
      name="selectDesde"
      ref={txtDesde}
      onChange={onChange}
      className="form-select form-select-sm"
      style={{ width: '120px' }}
    >
      <option value={1}>ENERO</option>
      <option value={2}>FEBRERO</option>
      <option value={3}>MARZO</option>
      <option value={4}>ABRIL</option>
      <option value={5}>MAYO</option>
      <option value={6}>JUNIO</option>
      <option value={7}>JULIO</option>
      <option value={8}>AGOSTO</option>
      <option value={9}>SEPTIEMBRE</option>
      <option value={10}>OCTUBRE</option>
      <option value={11}>NOVIEMBRE</option>
      <option value={12}>DICIEMBRE</option>
    </select>
    <label className="mb-0">Hasta</label>
    <select
      disabled={operacion === 1 || operacion === 2 ? false : true}
      name="selectHasta"
      ref={txtHasta}
      onChange={onChange}
      className="form-select form-select-sm"
      style={{ width: '120px' }}
      defaultValue={"12"}
    >
      <option value="1">ENERO</option>
      <option value="2">FEBRERO</option>
      <option value="3">MARZO</option>
      <option value="4">ABRIL</option>
      <option value="5">MAYO</option>
      <option value="6">JUNIO</option>
      <option value="7">JULIO</option>
      <option value="8">AGOSTO</option>
      <option value="9">SEPTIEMBRE</option>
      <option value="10">OCTUBRE</option>
      <option value="11">NOVIEMBRE</option>
      <option value="12">DICIEMBRE</option>
    </select>
  </div>

  {/* Monto */}
  <div className="d-flex align-items-center" style={{ gap: '5px' }}>
    <span className="mb-0">Monto a Pagar:</span>
    <input
      type="text"
      ref={txtMontoPagar}
      style={{ textAlign: 'right', width: '110px' }}
      disabled
      defaultValue={props.inmobiliaria && props.inmobiliaria.montoarrendamiento
        ? formatMoneda(props.inmobiliaria.montoarrendamiento.toString().replace(',', '').replace('.', ','), ',', '.', 2)
        : '0,00'}
      className="form-control form-control-sm text-right"
      id="montoPagar"
      onKeyUp={handleInputMonto}
      onBlur={handleInputMonto}
    />
  </div>

  {/* Botón */}
  <button
    disabled={operacion === 1 || operacion === 2 ? false : true}
    className="btn btn-sm btn-info"
    onClick={validarCamposDeuda}
  >
    Cargar
  </button>
</div>
                                    ) : (
                                        ""
                                    )}
                                </fieldset>





                            </div>
                        </div>

                        <div
                            className="tab-pane fade"
                            id="deuda"
                            role="tabpanel"
                            aria-labelledby="deuda-tab"
                        >
                            <div className="row col-md-12">
                                <TablaDeudasEjidos
                                    tabdeuda={desde1 === 0 ? props.deuda : deuda}
                                    idrentas={props.inmobiliaria && props.inmobiliaria.idrentas}
                                    visibleF={"hidden"}
                                    credito={
                                        props.credito && props.credito > 0 ? props.credito : 0.0
                                    }
                                />
                            </div>
                        </div>

                        <div
                            className="tab-pane fade"
                            id="historico"
                            role="tabpanel"
                            aria-labelledby="hist-tab"
                        >
                            <div className="row col-md-12">
                                <TablaHistoricosEjidos
                                    tabHis={props.historico}
                                    idrentas={props.inmobiliaria && props.inmobiliaria.idrentas}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-info col-md-2 rounded-pill"
                    onClick={() => imprimirRelacionPago()}
                >
                <i className="fas fa-print"/> PAGOS WEB
                </button>
                <button
                    className="btn btn-sm btn-success col-md-1 rounded-pill"
                    disabled={props.operacion === 4 ? true : false}
                    onClick={opcionesRegistro}
                >
                    <i className="fas fa-check-circle" /> Aceptar
                </button>
                <button
                    ref={btnCancela}
                    onClick={salir}
                    className="btn btn-sm btn-danger col-md-1 rounded-pill"
                >
                    <i className="fas fa-window-close"/> Salir
                </button>
            </Modal.Footer>
        </Modal>
    );
};
